'use client';
// Используется снаружи next-intl провайдера
// eslint-disable-next-line no-restricted-imports
import { useRouter } from 'next/navigation';
import { useTransition } from 'react';

import { Text } from '~components/Typography';

import { disableDraftMode } from './action';

export function DisableDraftMode({ perspective }: { perspective?: string }) {
	const router = useRouter();
	const [pending, startTransition] = useTransition();

	const disable = () =>
		startTransition(async () => {
			await disableDraftMode();
			router.refresh();
		});

	return (
		<div
			id="draft-mode"
			style={{
				position: 'fixed',
				zIndex: 1000,
				top: 0,
			}}
		>
			<Text size="XS" underline>
				{pending ? (
					'Disabling...'
				) : (
					<>
						<a onClick={disable}>Disable Draft Mode.</a> Perspective:{' '}
						<b>{perspective}</b>
					</>
				)}
			</Text>
		</div>
	);
}
